/**
 * Line icons for the sidebar, inline because the project has no icon package.
 *
 * <p>All 18px on a 24 grid with the same stroke weight, so nothing looks heavier than its
 * neighbours, and they take `currentColor` so an active item's white text carries the icon with it.
 */
const base = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export const DashboardIcon = () => (
  <svg {...base}>
    <rect x="3" y="3" width="7.5" height="8.5" rx="1.6" />
    <rect x="13.5" y="3" width="7.5" height="5" rx="1.6" />
    <rect x="3" y="14.5" width="7.5" height="6.5" rx="1.6" />
    <rect x="13.5" y="11" width="7.5" height="10" rx="1.6" />
  </svg>
);

export const RocketIcon = () => (
  <svg {...base}>
    <path d="M12 3c3.5 1.6 5.5 5 5.5 9l-2.6 2.6h-5.8L6.5 12C6.5 8 8.5 4.6 12 3Z" />
    <path d="M9.1 14.6 7 21l4-2 4 2-2.1-6.4" />
    <circle cx="12" cy="9.5" r="1.6" />
  </svg>
);

export const CampaignsIcon = () => (
  <svg {...base}>
    <path d="m3 10 13-5v14L3 14z" />
    <path d="M16 8.5a3.5 3.5 0 0 1 0 7" />
    <path d="M6.5 14.5V19a1.5 1.5 0 0 0 3 0v-3.6" />
  </svg>
);

export const BroadcastsIcon = () => (
  <svg {...base}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3.5 6.5 8.5 6 8.5-6" />
  </svg>
);

export const AssetsIcon = () => (
  <svg {...base}>
    <path d="m12 3 8.5 4.5L12 12 3.5 7.5 12 3Z" />
    <path d="m3.5 12 8.5 4.5 8.5-4.5" />
    <path d="m3.5 16.5 8.5 4.5 8.5-4.5" />
  </svg>
);

export const AnalyticsIcon = () => (
  <svg {...base}>
    <path d="M4 20V4" />
    <path d="M4 20h16" />
    <path d="m7.5 15.5 3.5-4 3 2.5 4.5-6" />
  </svg>
);

export const DocsIcon = () => (
  <svg {...base}>
    <path d="M6 3h7.5L19 8.5V21H6z" />
    <path d="M13 3v6h6" />
    <path d="M9 13h7M9 17h5" />
  </svg>
);

export const TeamIcon = () => (
  <svg {...base}>
    <path d="M15.5 20v-1a3.5 3.5 0 0 0-3.5-3.5H7A3.5 3.5 0 0 0 3.5 19v1" />
    <circle cx="9.5" cy="8" r="3.2" />
    <path d="M16.5 4.8a3.2 3.2 0 0 1 0 6.4M20.5 20v-1a3.5 3.5 0 0 0-2.8-3.4" />
  </svg>
);

export const ManagersIcon = () => (
  <svg {...base}>
    <circle cx="10" cy="8" r="3.2" />
    <path d="M4 20v-1a4 4 0 0 1 4-4h4" />
    <path d="m21 13.5-6.5 2.6 2.4 1.1 1.1 2.4z" />
  </svg>
);

export const DomainsIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.5 12h17" />
    <path d="M12 3.5a13 13 0 0 1 0 17a13 13 0 0 1 0-17" />
  </svg>
);

export const IntegrationsIcon = () => (
  <svg {...base}>
    <rect x="3.5" y="3.5" width="7" height="7" rx="1.8" />
    <rect x="13.5" y="3.5" width="7" height="7" rx="3.5" />
    <rect x="3.5" y="13.5" width="7" height="7" rx="1.8" />
    <path d="M17 13.5v7M13.5 17h7" />
  </svg>
);

export const BillingIcon = () => (
  <svg {...base}>
    <rect x="2.5" y="5" width="19" height="14" rx="2.4" />
    <path d="M2.5 10h19" />
    <path d="M6.5 14.5h3" />
  </svg>
);

export const WorkspaceIcon = () => (
  <svg {...base}>
    <rect x="2.5" y="7" width="19" height="13" rx="2.2" />
    <path d="M8.5 7V5.5A1.5 1.5 0 0 1 10 4h4a1.5 1.5 0 0 1 1.5 1.5V7" />
    <path d="M2.5 12.5h19" />
  </svg>
);

export const ChevronIcon = () => (
  <svg {...base} width={14} height={14}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const CollapseIcon = () => (
  <svg {...base} width={16} height={16}>
    <polyline points="14 6 8 12 14 18" />
    <path d="M4.5 5v14" />
  </svg>
);

export const MenuIcon = () => (
  <svg {...base} width={20} height={20}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);
